_collow.components.LoginChecker = class LoginChecker extends (
  _collow.components.Base
) {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();
    this.root = root;
    this.elements = elements;
    this.params = params;

    //required to make sure that this does not trigger before initiate other components
    window.onload = this.checkLogin;
    this.listen(document.body, "_collow.logout", this.emptyLocalStorage);
  }
  checkLogin = async () => {
    // check token time
    const tokenValidTime = window.localStorage.getItem("tokenValidTime");
    const currentTime = Math.round(new Date().getTime() / 1000);

    if (!tokenValidTime || currentTime > tokenValidTime) {
      this.dispatch(this.root, "_collow.not-logged-in");
      this.emptyLocalStorage();
      // Continue execution for unauthenticated users
      await this.checkLocalStorage();
      return;
    }
    const currentToken = window.localStorage.getItem("token");

    if (tokenValidTime - currentTime <= 3200) { // 3200 seconds = 1 hour
      const newToken = await fetch(this.params.path + "/user/auth", {
        method: "get",
        headers: {
          Authorization: currentToken,
        },
      })
        .then((response) => response.json())
        .catch((err) => console.error(err));

      if (newToken?.["access_token"]) {
        const token = newToken["token_type"] + " " + newToken["access_token"];
        localStorage.setItem("token", token);
        localStorage.setItem("tokenValidTime", newToken["time_expire"]);
        document.cookie = `_ctt=${newToken["time_expire"]}; path=/;`;
      } else {
        this.emptyLocalStorage();
        this.dispatch(this.root, "_collow.not-logged-in");
      }
    }
    await this.checkLocalStorage();
  };

  checkLocalStorage = async () => {
    let isCompanyAccount =
      window.localStorage.getItem("companyAccount") == "true";
    let progressJson = JSON.parse(window.localStorage.getItem("progressJson"));

    // Only try to fetch progressJson if we have a token
    const hasToken = !!localStorage.getItem("token");
    if (!progressJson && hasToken) {
      const endpoint =
        this.params.path + (isCompanyAccount ? "/company/me" : "/user/me");

      try {
        const response = await fetch(endpoint, {
          method: "get",
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        });

        progressJson = await response.json();
        if (progressJson) {
          localStorage.setItem("progressJson", JSON.stringify(progressJson));

          if (!isCompanyAccount) {
            document.cookie = `_r=${progressJson.role}; path=/;`;
          }
        }
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    }

    const currentUser = progressJson?.email || null;

    // Always fetch whitelabel features regardless of authentication status
    await this.getWhitelabelFeatures();

    // First dispatch an event that the whitelabel features are ready
    this.dispatch(window, "_collow.whitelabel-features-loaded");

    // Then dispatch the current user event
    this.dispatch(window, "_collow.current-user", {
      currentUser,
    });
  };

  /**
   * Gets the whitelabel accesible features and saves them on local storage
   * @returns
   */
  getWhitelabelFeatures = async () => {
    const url = this.params.path + "/settings/benefits";

    try {
      const response = await fetching(url, "GET");

      if (response) {
        localStorage.setItem("whitelabelFeatures", JSON.stringify(response));
        return response;
      }
      return null;
    } catch (error) {
      console.error("Failed to fetch whitelabel features:", error);
      return null;
    }
  };

  emptyLocalStorage = () => {
    ["progressJson", "tokenValidTime", "token", "companyAccount"].forEach(
      (item) => window.localStorage.removeItem(item)
    );
    document.cookie = `_ctt=; Expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;`;
    document.cookie = `_r=; Expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;`;
  };
};
